import { render, staticRenderFns } from "./EmitirSunat.vue?vue&type=template&id=63fa8fde"
import script from "./EmitirSunat.vue?vue&type=script&lang=js"
export * from "./EmitirSunat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports